import { useEffect } from 'react';
import { useOrderBookStore } from '../state/orderBookStore.ts';
import { UseOrderBookOptions } from '../state/types.ts';
import { useMarketWebSocketSender } from '../../../hooks/ws/useMarketWebSocketSender.ts';
import { MsgTypeSubscriptionRequest, SubscriptionRequest } from '@/api/spec.ts';

export function useDexOrderBookSubscriptions({ symbol, enabled = true }: UseOrderBookOptions) {
  const { sendMessage } = useMarketWebSocketSender();

  useEffect(() => {
    if (enabled && symbol && sendMessage) {
      useOrderBookStore.getState().connect(symbol);
      const orders = `order-book@${symbol}`;
      const trades = `trades@${symbol}`;
      sendMessage<SubscriptionRequest>({
        mt: MsgTypeSubscriptionRequest,
        subs: [
          { stream: orders, subscribe: true },
          { stream: trades, subscribe: true },
        ],
      });

      return () => {
        sendMessage<SubscriptionRequest>({
          mt: MsgTypeSubscriptionRequest,
          subs: [
            { stream: orders, subscribe: false },
            { stream: trades, subscribe: false },
          ],
        });
        useOrderBookStore.getState().reset();
      };
    } else {
      useOrderBookStore.getState().reset();
    }
  }, [symbol, enabled, sendMessage]);
}
